import React, { useEffect, useState } from 'react'
import api from './api'
import '../css/Sso.css'

import { useNavigate, useParams } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import { message, Avatar, Typography, Button, Result, Badge } from 'antd'

const { Title, Text, Link } = Typography


let ts = {
    'nzadmin': 'NZadmin 控制台 (nzadmin.cn)',
    'nzadminv2': 'NZadmin 控制台 V2 (nzadmin.cn)',
    'fivem': 'FiveM平台 (测试服)',
}

//  SSO 登陆 布局
function Sso(props) {
    const id = useParams()
    const navigate = useNavigate()
    const searchParams = new URLSearchParams(window.location.search)
    const [tname, setTname] = useState(searchParams.get('name'))
    const [code, setCode] = useState(200)
    const [fivem, setFiveM] = useState(false)
    const [wx, setWx] = useState(false)
    const [data, setData] = useState({ ctime: null })

    useEffect(() => {
        if (id && id.id) {
            //  本地存储 SSO ID, 方便在微信授权/登录/注册时自动跳转回来至本页面
            localStorage.setItem('login_sso_url', id.id)
        }

        api.post('/api/v2/open_access/sso', {
            name: 'vy',
            id: id.id,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    if (!res.data.data.data.vy) {
                        setCode(403)
                        return
                    }
                    if (res.data.data.data.wx) {
                        setWx(true)
                    }
                    setData(res.data.data.data)
                    setTname(res.data.data.data.tname)
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器 error: ' + error)
            })
    }, [])

    //  允许授权
    async function Authorization() {
        api.post('/api/v2/open_access/sso', {
            name: 'Authorization',
            id: id.id,
        })
            .then((res) => {
                if (res.data.code === 200) {

                    //  授权成功, 清理本地的 SSO ID 存储
                    localStorage.removeItem('login_sso_url')

                    const link = document.createElement('a')

                    let a = res.data.data.data.name
                    if (a === 'nzadmin') {
                        if (process.env.NODE_ENV === 'production') {
                            link.href = 'https://app.nzadmin.cn/login?token_id=' + res.data.data.data._id
                        } else {
                            link.href = 'http://localhost:4002/login?token_id=' + res.data.data.data._id
                        }
                    }

                    if (a === 'nzadminv2') {
                        if (process.env.NODE_ENV === 'production') {
                            link.href = 'https://app.nzadmin.cn/login?token_id=' + res.data.data.data._id
                            // link.href = 'http://localhost:5173/login?token_id=' + res.data.data.data._id
                        } else {
                            link.href = 'http://localhost:5173/login?token_id=' + res.data.data.data._id
                        }
                    }

                    if (a === 'fivem') {
                        setFiveM(true)
                        message.success('已完成授权, 请重新连接游戏!')
                        return
                    }

                    message.success('已允许授权, 正在跳转至目标网址中...')

                    // link.target = '_blank';  // 关键修改点
                    link.rel = 'noopener noreferrer'; // 安全建议

                    setTimeout(() => {
                        link.click()
                    }, 1500);

                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器 error: ' + error)
            })
    }


    //  获取微信
    async function AuthorizationWx() {
        const key = Date
        message.loading({ key, content: '正在请求中...', })

        api.post('/api/v2/open_access/sso', {
            name: 'getTpp',
            // id: id.id,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    const link = document.createElement('a')

                    link.href = res.data.data.data.url

                    message.success({ key, content: '已获取到验证地址, 正在跳转至目标网址中...' })

                    // link.target = '_blank';  // 关键修改点
                    link.rel = 'noopener noreferrer'; // 安全建议

                    setTimeout(() => {
                        link.click()
                    }, 1500);

                } else {
                    // message.error(res.data.data.text)
                    message.success({ key, content: res.data.data.text })
                }
            })
            .catch((error) => {
                // message.error('网络异常,无法连接服务器')
                message.success({ key, content: '网络异常,无法连接服务器 error: ' + error })
            })
    }

    if (!props.state.token) {
        navigate('/login')

        return (
            <Result
                status="403"
                title="403"
                subTitle="请登录再访问页面"
            />
        )
    }
    if (code === 403) {
        return (
            <Result
                status="403"
                title="403"
                subTitle="本次请求已失效, 请返回页面重新触发登录请求"
            />
        )
    }

    if (fivem) {
        return (
            <Result
                status="success"
                title={<>Hi, {props.state.user.name}, 欢迎回来, 您已完成授权登录, 请重新连接游戏!</>}
                subTitle="说明: 在24小时内登录自动延长免授权登录时间, 最长可延长至7天时间! (更换设备可能会触发需要重新授权登录)"
                extra={[
                ]}
            />
        )
    }

    // if (wx) {
    //     return (
    //         <>
    //             <Result
    //                 status="success"
    //                 title={<>Hi, {props.state.user.name}, 您需要进行微信验证!</>}
    //                 subTitle="说明: 为确保您的账户安全性, 我们需要验证您的微信作为身份合规性检查, 同时您也可以选择不验证, 这可能会导致部分功能无法正常使用。"
    //                 extra={[
    //                 ]}
    //             />

    //             <Button type="primary" size='large' block onClick={() => { AuthorizationWx() }}>微信验证</Button>
    //         </>
    //     )
    // }

    return (
        <Badge.Ribbon text="授权第三方登录">
            <div className='sso'>
                <div className='avatar'>
                    <Avatar size={64} src={props.function.getAvatar()} />
                </div>
                <Title level={3} style={{ textAlign: 'center' }}>{props.state.user.name}</Title>

                <ul style={{ marginTop: 50, marginBottom: 50, color: '#fff' }}>
                    <li><Text>来自 <Link>{ts[tname]}</Link> 的网页</Text></li>
                    <li><Text>授权获取 <Link>用户信息</Link> 权限</Text></li>
                </ul>

                <div style={{ marginBottom: 20, float: 'right' }}><Text type="secondary">请求创建时间 <Link>{data.ctime}</Link></Text></div>

                <Button type="primary" size='large' block onClick={Authorization}>授权登录</Button>

            </div>
        </Badge.Ribbon>
    )
}

export default Sso;